import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import { Formik } from 'formik'
import { editEndpointList,executeEndpointList, deleteEndpointList } from '../actions/endpoints'
import { fetchEndpointIfNeeded as ftch } from '../actions/fetch'
// import MappingFieldTable from './MappingFieldTable'
// import ScheduleForm from './scheduleForm'
// import Subtask from './utilities/tabs/Subtask';
// import IntegrationFilterForm from './integrationFilterForm'
// import JSONForm from './utilities/JSONForm'
import NavItem from './utilities/NavItem'
import NavContent from './utilities/NavContent'
import NewIntegrationForm from './newIntegrationForm'
import FormButtonPanel from './utilities/FormButtonPanel'
import { CSSTransition } from "react-transition-group"
import Statuspick from './statuspick'
import { showMessage } from '../actions/messageBox'
import JsonTableViewer from './utilities/tabs/jsontable'
import JoblogJsonTableViwer from './utilities/tabs/JoblogJsonTable'
import moment from 'moment'
import 'moment-timezone'


class IntegrationForm extends Component {
    constructor(props) {
        super(props)

        this.onIntegrationDelete = this.onIntegrationDelete.bind(this)
        /**
         * Initialize the Refs, so we can remotely call their submit functions
         * when Save button is clicked
         */
        this.fieldMappingRef = null
        this.scheduleRef = null

        this.state = {
            integrationForm: this.props.list,
            scheduleForm: this.props.schedule,
            fieldMappingLocked: false
        }
    }

    componentWillReceiveProps(nextProps) {

        let newIntegrationValues = this.state.integrationForm === undefined && nextProps.list !== undefined ? nextProps.list : this.state.integrationForm
        let newScheduleValues = this.state.scheduleForm === undefined && nextProps.schedule !== undefined ? nextProps.schedule : this.state.scheduleForm

        this.setState({
            integrationForm: newIntegrationValues,
            scheduleForm: newScheduleValues,
        })
    }

    componentDidMount() {
        this.props.dispatch(ftch(1, true))
        this.props.dispatch(ftch(2, true))
        this.props.dispatch(ftch(11, true))
        this.props.dispatch(ftch(12, true))
        this.props.dispatch(ftch(17, true))
        this.props.dispatch(ftch(7, true))
        this.props.dispatch(ftch(15, true))
    }

    onIntegrationDelete() {
        let {
            endpoints,
            dispatch,
            list,
            mappingId,
            endpointId,
            endpointName,
            accessToken,
            history,
            parentUrl,
            schedule
        } = this.props


        let fieldMappingCount = endpoints
            .find(endpoint => endpoint.name === "datasourcemappingfields").list
            .filter(mapField => mapField.mapping_id === mappingId).length

        let unsavedFieldMappinCount = this.fieldMappingRef &&
            this.fieldMappingRef.state.mappingFields &&
            this.fieldMappingRef.state.mappingFields.length

        if (fieldMappingCount || unsavedFieldMappinCount) {
            dispatch(
                showMessage({
                    type: "error",
                    title: "Action is not allowed",
                    message: "Please delete all field mapping before deleting the integration"
                })
            )
        } else {
            dispatch(showMessage({
                type: "info",
                title: "Confirmation",
                message: "Deleting this integration cannot be undone, are you sure you want to proceed?",
                timeout: 0,
                buttonArray: ["Yes", "No"],
                onClick: (buttonIndex) => {
                    // If yes button was clicked
                    if (buttonIndex === 0 && schedule && schedule.id && mappingId && list && list.id) {

                        let deleteSequence = [
                            [11, "datasourcemappings", mappingId, accessToken],
                            [2, "schedules", schedule.id, accessToken],
                            [endpointId, endpointName, list.id, accessToken],
                        ]

                        deleteSequence.reduce((previousPromise, nextDelete) => {
                            return previousPromise.then(() => {
                                return dispatch(deleteEndpointList(...nextDelete))
                            })
                        }, Promise.resolve()).then(jsonObj => {
                            if (jsonObj.response.ok) {
                                dispatch(showMessage({
                                    type: "success",
                                    title: "Deleted",
                                    message: `${list.name} has been deleted`,
                                    onClick: () => {
                                        history.push(parentUrl)
                                    }
                                }))
                            }
                        })
                    }
                }
            }))
        }

    }

    render() {
        let {
            list,
            formType,
            mappingId,
            schedule,
            endpointName,
            // endpointId,
            // isFetching,
            endpoints,
            datasourcemapping,
            allowMappingChange,
            datasources,
            integrationOptions,
            integrationOptionsJSONStr,
            accessToken,
            dispatch,
            history,
            parentUrl,
            isUserAdmin
        } = this.props



        let {
            integrationForm,
            scheduleForm
        } = this.state

        // Initialize an empty object
        let objProp = {}

        let IntegrationFields = ['Name', 'Description', 'Handler', 'Created by', 'Created at', 'Updated by', 'Updated at']
        let RequiredFields = ['Name', 'Description', 'Handler']
        let additionalTabs = ['Audit','Execution']
        let jsonFormTabList = []
        let jsonFormFields = []
        let jsonFormCounter = 0
        let keycount = 0
        let renderView = ""
        let getTaskList
        let getUserList
        let getJoblogList


        for (let n in endpoints) {
            if (endpoints[n].name === "audits") {
                getTaskList = endpoints[n].list
            } else if (endpoints[n].name === "users") {
                getUserList = endpoints[n].list
            } else if (endpoints[n].name === "joblogs"){
                getJoblogList = endpoints[n].list
            }
        }

        


    
        let getId = list && list.id

        // console.log("getId",getId)

        let filterAuditList = getTaskList.filter(fal => fal.document_id === getId && fal.document_type === "task")
        let filterJoblogList = getJoblogList.filter(fjl => fjl.task_id === getId )



        // Initial values
        let initVal = Object.assign({}, {            
            datasourcemapping: { ...datasourcemapping },
            schedule: { ...scheduleForm },
            integrationOptions: integrationOptions,
            integrationOptionsJSONStr: integrationOptionsJSONStr
        }, objProp)


        // Format the dates correctly using moment
        if (initVal.schedule !== undefined && initVal.schedule.start_date)
            initVal.schedule.start_date = moment(initVal.schedule.start_date, 'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)').tz("UTC").format("YYYY-MM-DD")
        if (initVal.schedule !== undefined && initVal.schedule.end_date)
            initVal.schedule.end_date = moment(initVal.schedule.end_date, 'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)').tz("UTC").format("YYYY-MM-DD")

        // let filters = ( list && list.options && list.options.includes( 'filters') ) ?
        //     JSON.parse( list.options ).filters: ''

        initVal = integrationForm !== undefined ?
            Object.assign({}, initVal, {
                name: integrationForm.name,
                description: integrationForm.description,
                handler: integrationForm.handler,
                created_by: integrationForm.created_by,
                created_at: integrationForm.created_at,
                updated_by: integrationForm.updated_by,
                updated_at: integrationForm.updated_at,
                status: integrationForm.status,
                list: integrationForm
            }) : initVal


        if(isUserAdmin){
            for (let a in additionalTabs) {
                if (additionalTabs[a] === "Audit") {
                    jsonFormTabList.push(
                        <NavItem
                            active={""}
                            key={`${additionalTabs[a]}-${keycount}-tabheader`}
                            name={`${additionalTabs[a]}-${keycount}`}
                            value={additionalTabs[a]}
                            selected={true}
                        />
                    )
                    jsonFormFields.push(
                        <NavContent
                            key={`${additionalTabs[a]}-${keycount}-tabcontent`}
                            id={`${additionalTabs[a]}-${keycount}`}
                            active={""}
                            content={
                                <div className="p-2">
                                    <JsonTableViewer value={filterAuditList} user={getUserList} endpoint={endpointName} additional={"options"}/>
                                </div>
                            }
                        />
                    )
                }else if(additionalTabs[a] === "Execution"){
                    jsonFormTabList.push(
                        <NavItem
                            active={""}
                            key={`${additionalTabs[a]}-${keycount}-tabheader`}
                            name={`${additionalTabs[a]}-${keycount}`}
                            value={`${additionalTabs[a]} Logs`}
                            selected={true}
                        />
                    )
                    jsonFormFields.push(
                        <NavContent
                            key={`${additionalTabs[a]}-${keycount}-tabcontent`}
                            id={`${additionalTabs[a]}-${keycount}`}
                            active={""}
                            content={                  
                                <div className="p-2">
                                  <JoblogJsonTableViwer value={filterJoblogList} user={getUserList} endpoint={endpointName} additional={"options"}/>
                                </div>
                            }
                        />
                    )
                }
                keycount++
                jsonFormCounter++
            }
        }

        let fieldMappingCount = endpoints
            .find(endpoint => endpoint.name === "datasourcemappingfields").list
            .filter(mapField => mapField.mapping_id === mappingId).length

        return (
            formType === 'edit' ?
                (
                    initVal.name !== undefined &&
                    <div id="working-area-content">
                        <div className="">
                            <Formik
                                enableReinitialize
                                initialValues={initVal}
                                validate={(values) => {
                                    let errors = {}
                                    let nameRestriction = /^[a-zA-Z0-9-_]+$/

                                    if (!values.name) {
                                        errors.name = "This field is required"
                                    } else if (!nameRestriction.test(values.name)) {
                                        errors.name = "Special characters and spaces not allowed"
                                    }
                                    if (!values.description) {
                                        errors.description = "This field is required"
                                    }
                                    if (!values.handler) {
                                        errors.handler = "This field is required"
                                    }

                                    return errors
                                }}
                                onSubmit={(values) => {

                                    //Convert User name to userid upon submit
                                    let userEndpoint = endpoints.find(userEndP => userEndP.name === 'users')

                                    let UpdateUserId = userEndpoint.list.find(usId => usId.username === values.updated_by)
                                    let CreateUserId = userEndpoint.list.find(cuId => cuId.username === values.created_by)

                                    let getUpdateUserId = UpdateUserId && UpdateUserId.id
                                    let getCreateUserId = CreateUserId && CreateUserId.id


                                    values.updated_by = getUpdateUserId
                                    values.created_by = getCreateUserId

                                    let integrationForm = {
                                        ...values.list,
                                        name: values.name,
                                        description: values.description,
                                        handler: values.handler,
                                        status: values.status,
                                        options: values.integrationOptionsJSONStr
                                    }

                                    if (integrationForm.status === 0 && values.schedule && values.schedule.status === 1) {
                                        dispatch(editEndpointList(2, "schedules", accessToken, { id: values.schedule.id, status: 0 }, "PATCH"))
                                    }


                                    dispatch(editEndpointList(11, 'datasourcemappings', accessToken, { ...values.datasourcemapping }))

                                    dispatch(editEndpointList(1, 'tasks', accessToken, integrationForm)).then(respObj => {
                                        
                                    // console.log("integrationForm",integrationForm)
                                        if (!respObj.response.ok && isUserAdmin) {
                                            this.props.dispatch(
                                                showMessage({
                                                    type: "error",
                                                    title: "Error",
                                                    message: "There were errors when saving the integration"
                                                })
                                            )
                                        } else if(respObj.response.ok && isUserAdmin){
                                            let message = values.hasOwnProperty("name") ?
                                                `${values.name} successfully saved` :
                                                "Successfully saved"
                                            dispatch(showMessage({
                                                type: "success",
                                                title: "Success",
                                                message: message,
                                                onClick: () => {
                                                    history.push(parentUrl)
                                                }
                                            }))
                                        }else if(respObj.response.ok && !isUserAdmin) {
                                            this.props.dispatch(
                                                showMessage({
                                                    type: "error",
                                                    title: "Not Authorize",
                                                    message: "Sorry, you don't have permission to save "
                                                })
                                            )
                                        }

                                        dispatch(ftch(15, true))
                                        dispatch(ftch(17, true))
                                        this.setState({ fieldMappingLocked: false })
                                        return respObj
                                    })
                                }}
                                render={({
                                    handleSubmit,
                                    handleChange,
                                    values,
                                    errors
                                }) => {
                                    //Convert User id to Username to view
                                    let userEndpoint = endpoints.find(userEndP => userEndP.name === 'users')

                                    let associatedUpdateUser = userEndpoint.list.find(uUser => uUser.id === values.updated_by)
                                    let associatedCreateUser = userEndpoint.list.find(cUser => cUser.id === values.created_by)

                                    let getAssociatedUpdateUserName = associatedUpdateUser && associatedUpdateUser.username
                                    let getAssociatedCreateUserName = associatedCreateUser && associatedCreateUser.username
                                    let getAssociatedUpdateId = associatedUpdateUser && associatedUpdateUser.id
                                    let getAssociatedCreateId = associatedCreateUser && associatedCreateUser.id

                                    
                                    let currentUser = userEndpoint.list.find(cUser => cUser.id === this.props.auth.user.id)
                                    let currentUsername = currentUser && currentUser.username


                                    getAssociatedUpdateUserName ? values.updated_by = getAssociatedUpdateUserName : getAssociatedUpdateId
                                    getAssociatedCreateUserName ? values.created_by = getAssociatedCreateUserName : getAssociatedCreateId

                                    renderView = <div className="row mx-0 mt-0 datasourcemapping-section">
                                        <div className="col-6 mt-3">
                                            <label className="my-0">From: Datasource*</label>
                                            <select onChange={handleChange} disabled={fieldMappingCount > 0} name="datasourcemapping.datasource_id" value={values.datasourcemapping ? values.datasourcemapping.datasource_id : ""} className={"form-control" + (errors && errors.datasourcemapping && errors.datasourcemapping.hasOwnProperty("datasource_id") ? " is-invalid" : "")}>
                                                {
                                                    datasources.map(d => {
                                                        let hideOption = (Number(values.datasourcemapping.datatarget_id) === d.id)
                                                        let inactive = !d.status
                                                        let hideInactive = (Number(values.datasourcemapping.datasource_id)) !== d.id && inactive
                                                        return (
                                                            <option key={d.id} value={d.id} className={hideOption || hideInactive ? "d-none" : ""}>
                                                                {d.name} {inactive && "(Inactive)"}
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </select>
                                            <div className="invalid-feedback">
                                                {errors && errors.datasourcemapping && errors.datasourcemapping.hasOwnProperty("datasource_id") ? errors.datasourcemapping.datasource_id : ""}
                                            </div>
                                        </div>
                                        <div className="col-6 mt-3">
                                            <label className="my-0">To: Datasource*</label>
                                            <select onChange={handleChange} disabled={fieldMappingCount > 0} name="datasourcemapping.datatarget_id" value={values.datasourcemapping ? values.datasourcemapping.datatarget_id : ""} className={"form-control" + (errors && errors.datasourcemapping && errors.datasourcemapping.hasOwnProperty("datatarget_id") ? " is-invalid" : "")}>
                                                {
                                                    datasources.map(d => {
                                                        let hideOption = (Number(values.datasourcemapping.datasource_id) === d.id)
                                                        let inactive = !d.status
                                                        let hideInactive = (Number(values.datasourcemapping.datatarget_id)) !== d.id && inactive
                                                        return (
                                                            <option key={d.id} value={d.id} className={hideOption || hideInactive ? "d-none" : ""}>
                                                                {d.name} {inactive && "(Inactive)"}
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </select>
                                            <div className="invalid-feedback">
                                                {errors && errors.datasourcemapping && errors.datasourcemapping.hasOwnProperty("datatarget_id") ? errors.datasourcemapping.datatarget_id : ""}
                                            </div>
                                        </div>
                                    </div>

                                    let fields = []

                                    fields.push(
                                        <div key="integration-status" className="prop-header">
                                            <div className="col-12 px-1 mt-3"
                                                id="transform-input-type"
                                            >
                                                <div className="col-2 px-2">
                                                    <label htmlFor="status">
                                                        Active
                                                </label>
                                                </div>
                                                <div className="col-12 px-2">
                                                    <Statuspick
                                                        id="status"
                                                        name="status"
                                                        className="form-control"
                                                        onChange={handleChange}
                                                        defaultChecked={values["status"] === 1}
                                                        status={values["status"]}
                                                        showText={true}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )

                                    for (let l of IntegrationFields) {
                                        let h = l.toLowerCase().replace(/ /g, "_")
                                        let classStatus = "form-control" + (errors && errors[h] ? " is-invalid" : "")
                                        let statusValue = ''
                                        if (h === 'status') {

                                            classStatus = 'form-control-plaintext'

                                            if (values[h] === 0) {
                                                statusValue = 'Stopped'
                                            } else {
                                                statusValue = 'Running'
                                            }
                                        }else if( h==="created_by"){

                                            statusValue = getAssociatedCreateUserName? getAssociatedCreateUserName : getAssociatedCreateId
                                       
                                        }else if(h === "updated_by" ){
                                            statusValue = getAssociatedUpdateUserName ? getAssociatedUpdateUserName : getAssociatedUpdateId
                                        
                                        }else if(h === "updated_at" || h==="created_at"){
                                            statusValue= moment(values[h]).format('MM-DD-YYYY HH:mm:ss')
                                        } else {
                                            statusValue = values[h]
                                        }

                                        //check readonly
                                        let is_readonly = false;

                                        if (h === "updated_by" || h === "updated_at" || h === "created_by" || h === "created_at") {
                                            is_readonly = true;
                                        }else if ((h === "name" || h === "description" || h=== "handler") && isUserAdmin == false){
                                            is_readonly = true;
                                        }


                                        fields.push(

                                            <div key={h} className="prop-header">
                                                <div className="col-12 px-1 mt-3"
                                                    id="transform-input-type"
                                                >
                                                    <div className="col-12 px-2">
                                                        <label htmlFor={h}>
                                                            {h === 'status' ? 'Active' : l + (RequiredFields.includes(l) ? "*" : "")}
                                                        </label>
                                                    </div>
                                                    <div className="col-12 px-2">
                                                        {h === 'status' ?
                                                            <Statuspick
                                                                id={h}
                                                                name={h}
                                                                className="form-control"
                                                                onChange={handleChange}
                                                                defaultChecked={values[h] === 1}
                                                                status={values[h]}
                                                                showText={true}
                                                            /> :
                                                            (is_readonly ? 
                                                                <label> 
                                                                    {statusValue} 
                                                                    </label>
                                                                : <input
                                                                    className={classStatus}
                                                                    type="text"
                                                                    name={h}
                                                                    id={h}
                                                                    onChange={handleChange}
                                                                    value={statusValue}
                                                                    readOnly={is_readonly ? 'readonly' : false}
                                                                />)
                                                        }
                                                        <div className="invalid-feedback">
                                                            {errors && errors[h] ? errors[h] : ""}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        )
                                    }
                                    return (
                                        <CSSTransition
                                            in={true}
                                            appear={true}
                                            timeout={500}
                                            classNames="fade"
                                        >
                                            <div className="form-area-wrapper">

                                                <form onSubmit={handleSubmit}>
                                                    <div className="add-field-wrapper">
                                                        <div key="btn-panel-top" className="absolute-btn">
                                                            <FormButtonPanel
                                                                endpointName={'Integrations'}
                                                                isFetching={this.props.isFetching}
                                                                allowDelete={isUserAdmin}
                                                                onDelete={this.onIntegrationDelete}
                                                                formType="edit"
                                                                parentUrl="/integrations"
                                                                isAdmin={isUserAdmin}
                                                                isActive={list && list.status && list.status === 1 ? false : true}
                                                                onExecuteTask={(e)=>{
                                                                    this.setState((state) => {
                                                                        return Object.assign({}, state, 
                                                                        {
                                                                            isButtonClicked: true
                                                                            //currentClickedButtonId: e.target.id ? e.target.id : null
                                                                        });
                                                                    }, () => {
                                
                                                                        let getTaskId = list.id
                                                                        let getCreatedAt = list.created_at
                                                                        let getUpdatedAt = list.updated_at
                                                                        let dateNow = moment(new Date()).tz('UTC').format('YYYY-MM-DD HH:mm:ss')
                                                                        let data={
                                                                            "run_datetime": dateNow,
                                                                            "is_processed": "F",
                                                                            "process_status": "PENDING",
                                                                            "status": 0,
                                                                            "process_start_at": dateNow,
                                                                            "task_id": getTaskId,
                                                                            "queue_no": 1,
                                                                            'task_name': list.name
                                                                        }
                                    
                                                                        if(getTaskId && data){
                                                                            
                                                                           this.props.dispatch(executeEndpointList(
                                                                                "jobqueues",
                                                                                this.props.auth.access_token,
                                                                                data,
                                                                                "POST"
                                                                            )).then(response=>{
                                                                                if(response){
                                                                                    this.props.dispatch(showMessage({
                                                                                        type: "success",
                                                                                        title: "Success",
                                                                                        message: <span><b>{data.task_name}</b> has been successfully added to job-queue.</span>,
                                                                                        onClick: () => {
                                                                                            this.props.history.push("/job-queues")
                                                                                        }
                                                                                    }))
                                                                                }
                                                                                
                                                                                this.setState((state) => {
                                                                                    return Object.assign({}, state, 
                                                                                    {
                                                                                        isButtonClicked: false,
                                                                                    });
                                                                                });
                                                                            })
                                                                        }                                       
                                                                        
                                                                    });    
                                                                    
                                                                }}
                                                            />
                                                        </div>

                                                        <div className="col float-right">
                                                            <div key className="btn-group align-items-center justify-content-center float-right" role="group" aria-label="object functions">
                                                                <Link to={`/integrations/${values.list.id}/mapping`} className="btn">
                                                                    Field Mapping <i className="fas fa-angle-double-right"></i>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="integration-main-pane">
                                                        <div className="prop-header">
                                                            {fields}
                                                        </div>
                                                    </div>
                                                    <div className="integration-details-pane">
                                                        <div className="prop-details">
                                                            <div className="JSONForm">
                                                                <div className="card-header" id="card-property-header">
                                                                    <div className="row">
                                                                        <div className="col JSON-form-title">
                                                                            <span className="">&nbsp;</span>
                                                                        </div>
                                                                        <div className="col float-right">
                                                                            <div className="btn-group align-items-center justify-content-center float-right" role="group" aria-label="object functions">
                                                                                <Link to={`/integrations/${values.list.id}/mapping`} className="btn">
                                                                                    Field Mapping <i className="fas fa-angle-double-right"></i>
                                                                                </Link>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="integration-json-pane">
                                                                    <div className="integration-data-wrapper">
                                                                        <div className="json-data-header">
                                                                            <ul className="nav nav-tabs" id="json-tab" role="tablist">
                                                                                <NavItem
                                                                                    active={"active"}
                                                                                    key={`Integration-${keycount}-tabheader`}
                                                                                    name={`Integration-${keycount}`}
                                                                                    value={"Integration"}
                                                                                    selected={true}
                                                                                />
                                                                                {jsonFormTabList}
                                                                            </ul>
                                                                        </div>
                                                                        <div className="tab-content margined" id="generic-tab-content">
                                                                            <NavContent
                                                                                key={`Integration-${keycount}-tabcontent`}
                                                                                id={`Integration-${keycount}`}
                                                                                active={"show active"}
                                                                                content={
                                                                                    <div className="p-2">
                                                                                        {renderView}
                                                                                    </div>
                                                                                }
                                                                            />
                                                                            {jsonFormFields}

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </CSSTransition>
                                    )
                                }}
                            >
                            </Formik>
                        </div>
                    </div>
                ) :

                <CSSTransition
                    in={true}
                    appear={true}
                    timeout={500}
                    classNames="fade"
                >
                    <div id="form-area-wrapper">
                        <NewIntegrationForm parentUrl={parentUrl} />
                    </div>
                </CSSTransition>

        )
    }
}

function mapStateToProps(state, ownProps) {
    let lid = ownProps.location.pathname.split('/').pop()
    let epl = ownProps.endpoint.list
    let list = ownProps.formType === 'edit' ?
        epl.find(l => l.id === Number(lid)) :
        ownProps.endpoint.form
    let integrationOptions = list && list.options ?
        JSON.parse(list.options) : {}
    let integrationOptionsJSONStr = list && list.options ? list.options : "{}"
    let mappingId = Number(integrationOptions.datasourcemapping_id)
    let datasourcemapping = state.endpoints.find(endpoint => endpoint.name === 'datasourcemappings')
        .list.find(datasourcemapping => datasourcemapping.id === mappingId)

    // Try to find a mapping field, if 1 exists, do not allow change to datasourcemapping
    let allowMappingChange = false
    let mappingField = state.endpoints.find(endpoint => endpoint.name === 'datasourcemappingfields')
        .list.find(datasourcemappingfield => datasourcemappingfield.mapping_id === mappingId)
    if (mappingField === undefined) {
        allowMappingChange = true
    }

    let datasources = state.endpoints.find(endpoint => endpoint.name === 'datasources').list

    let scheduleId = integrationOptions.schedule_id
    let schedule = state.endpoints.find(endpoint => endpoint.name === 'schedules')
        .list.find(schedule => schedule.id === scheduleId)

    let isUserAdmin = state.auth.user && state.auth.user.isAdmin

    return {
        list: list,
        endpointId: ownProps.endpoint.id,
        endpointName: ownProps.endpoint.name,
        accessToken: state.auth.access_token,
        isFetching: ownProps.endpoint.isFetching,
        formType: ownProps.formType,
        parentUrl: ownProps.parentUrl,
        integrationOptions: integrationOptions,
        integrationOptionsJSONStr: integrationOptionsJSONStr,
        mappingId: mappingId,
        datasources: datasources,
        datasourcemapping: datasourcemapping,
        allowMappingChange: allowMappingChange,
        schedule: schedule,
        endpoints: state.endpoints,
        main: state.main,
        isUserAdmin: isUserAdmin
    }
}

export default withRouter(connect(mapStateToProps)(IntegrationForm))


// WEBPACK FOOTER //
// ./src/components/integrationForm.js